import React, { useMemo } from "react";
import styled from "styled-components";

import { Line } from "./Line";
import {
  CartesianGraphProps,
  getImageCoordsFromCartesianCoords,
} from "./utils";

const Styled = styled.g`
  line {
    stroke: #e5e5e5;
    shape-rendering: crispEdges;
  }
`;

interface Props {
  graph: CartesianGraphProps;
}

const CartesianGrid: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const gridlines = useMemo(() => {
    const yAxisGridlines: number[] = [];
    for (
      let index = Math.ceil(props.graph.y.min);
      index < Math.ceil(props.graph.y.max);
      index++
    ) {
      if (
        props.graph.y.gridDistance !== undefined &&
        index % props.graph.y.gridDistance !== 0
      ) {
        continue;
      }

      yAxisGridlines.push(index);
    }

    const xAxisGridlines: number[] = [];
    for (
      let index = Math.ceil(props.graph.x.min);
      index < Math.ceil(props.graph.x.max);
      index++
    ) {
      if (
        props.graph.x.gridDistance !== undefined &&
        index % props.graph.x.gridDistance !== 0
      ) {
        continue;
      }

      xAxisGridlines.push(index);
    }

    return {
      x: xAxisGridlines,
      y: yAxisGridlines,
    };
  }, [props.graph]);

  return (
    <Styled>
      {gridlines.y.map((int) => {
        return (
          <Line
            key={int}
            start={getImageCoordsFromCartesianCoords(props.graph, {
              x: props.graph.x.min,
              y: int,
            })}
            end={getImageCoordsFromCartesianCoords(props.graph, {
              x: props.graph.x.max,
              y: int,
            })}
          />
        );
      })}
      {gridlines.x.map((int) => {
        return (
          <Line
            key={int}
            start={getImageCoordsFromCartesianCoords(props.graph, {
              x: int,
              y: props.graph.y.min,
            })}
            end={getImageCoordsFromCartesianCoords(props.graph, {
              x: int,
              y: props.graph.y.max,
            })}
          />
        );
      })}
    </Styled>
  );
};

export default CartesianGrid;
